import React, { useEffect, useRef, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { phoneNumberRangeRegex } from '../../../../function/Regex';
import { validateForm } from '../../../../function/FormValidation';
import {
  getCompanyDetails,
  hospitalityGetDateTimeFormatList,
  retailerGetDateTimeFormatList,
  updateCompany
} from '../../../../api/AccountSetup';
import ToastNotification from '../../../../common/ToastNotification';
import { countrycodes } from '../../../../country-code/CountryCodes';
import CountryCode from '../../../../common/CountryCode';
import CountryCode2 from '../../../../common/CountryCode2';
import Slack from '../../../../assets/Slack.png';
import AccountSetupInputBox from '../../../../common/AccountSetupInputBox';
import AccountSetupButton from '../../../../common/AccountSetupButton';

interface CompanyDetails {
  companyName: string;
  industry: string;
  address: string;
  addressState: string;
  addressCountry: string;
  phone: string;
  code?: string;
  country?: string;
  supportEmail?: string;
  whatsAppNumber?: string;
  email?: string;
  whatsAppCountryCode?: string;
  cin: string;
  tin: string;
  dateTimeFormat: string;
}
interface Country {
  code: string;
  flag: string;
  name: string;
  teleCode: string;
}

interface ICreateCompanyProfileProps {
  isSettings: boolean;
}
const CreateCompanyProfile = (props: ICreateCompanyProfileProps) => {
  const { isSettings } = props;

  const navigate = useNavigate();

  const uuid = sessionStorage.getItem('companyUuid');
  const businessType = sessionStorage.getItem('businessType');
  const [searchParams] = useSearchParams();
  const code = searchParams.get('code');
  const dropdownRef = useRef<HTMLDivElement>(null);
  const dropdownRef1 = useRef<HTMLDivElement>(null);

  const [formData, setFormData] = useState<any>({
    companyName: '',
    contactNumber: '',
    Countrycode: '',
    Countryname: '',
    supportEmail: '',
    address: '',
    addressState: '',
    addressCountry: '',
    whatsAppNumber: '',
    email: '',
    whatsAppCountryCode: '',
    slack: false,
    cin: '',
    tin: '',
    dateTimeFormat: ''
  });
  const [errors, setErrors] = useState<{ [key: string]: string }>({});
  const [disable, setDisable] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [isWhatsappOpen, setIsWhatsappOpen] = useState(false);
  const [selectedCountry, setSelectedCountry] = useState<Country | null>(null);
  const [selectedWhatsAppCountry, setSelectedWhatsAppCountry] = useState<Country | null>(null);
  const [searchQuery, setSearchQuery] = useState('');
  const [searchQuerywhatsaap, setSearchQueryWhatsaap] = useState('');
  const [dateTimeFormatList, setDateTimeFormatList] = useState<any[]>([]);
  const [selectedDateTimeFormat, setSelectedDateTimeFormat] = useState('');

  const filteredCountries = countrycodes?.filter(
    (country: Country) =>
      country.teleCode.includes(searchQuery) ||
      country.code.toLowerCase().includes(searchQuery) ||
      country.name.toLowerCase().includes(searchQuery)
  );

  const filteredCountrieswhatsaap = countrycodes?.filter(
    (country: Country) =>
      country.teleCode.includes(searchQuerywhatsaap) ||
      country.code.toLowerCase().includes(searchQuerywhatsaap) ||
      country.name.toLowerCase().includes(searchQuerywhatsaap)
  );

  const toggleDropdown = () => setIsOpen(!isOpen);
  const toggleWhatsappDropdown = () => setIsWhatsappOpen(!isWhatsappOpen);

  const handleSelect = (country: Country) => {
    setSelectedCountry(country);
    setIsOpen(false);
    setErrors((prevErrors) => ({
      ...prevErrors,
      contactNumber: ''
    }));
  };

  const handleWhatsAppSelect = (country: Country) => {
    setSelectedWhatsAppCountry(country);
    setIsWhatsappOpen(false);
    setErrors((prevErrors) => ({
      ...prevErrors,
      whatsAppNumber: ''
    }));
  };

  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchQuery(e.target.value.toLowerCase());
  };

  const handelSearchWhatsaap = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchQueryWhatsaap(e.target.value.toLowerCase());
  };

  const getDateTimeFormatList = async () => {
    const response =
      businessType === 'Retail'
        ? await retailerGetDateTimeFormatList()
        : await hospitalityGetDateTimeFormatList();
    if (response) {
      setDateTimeFormatList(response.payload);
    } else {
      ToastNotification({
        message: response.message,
        type: 'warning'
      });
    }
  };

  useEffect(() => {
    getDateTimeFormatList();
  }, []);

  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    // const errorMessages: Record<string, string> = {
    //   contactNumber: formData.Countrycode === '+91' && value.length !== 10 ? 'Contact Number must be 10 digits' : '',
    //   whatsAppNumber: formData.whatsAppCountryCode === '+91' && value.length !== 10 ? 'WhatsApp Number must be 10 digits' : '',
    //   address: value.length < 5 || value.length > 255 ? 'Address must be between 5 and 255 characters' : ''
    // };

    // setErrors(prev => ({ ...prev, [name]: errorMessages[name] || '' }));

    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: ''
    }));
  };

  // const handlePhoneChange = (value: string) => {
  //   setFormData((prevData: any) => ({
  //     ...prevData,
  //     Countrycode: value
  //   }));
  // };

  const handleCreateCompanyProfile = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const { isValid, errors } = validateForm(formData, [
      'companyName',
      'address',
      'supportEmail',
      'contactNumber',
      'whatsAppNumber',
      'email',
      'addressCountry',
      'addressState',
      'dateTimeFormat'
    ]);
    setErrors(errors);
    if (errors && Object.keys(errors).length > 0) {
      setDisable(false);
    } else {
      setDisable(true);
    }
    if (isValid) {
      try {
        const response = await updateCompany(
          {
            companyName: formData.companyName,
            contactNumber: formData.contactNumber,
            supportEmail: formData.supportEmail || null,
            address: formData.address,
            whatsAppNumber: formData.whatsAppNumber,
            email: formData.email,
            code: formData.Countrycode || '+91',
            country: formData.Countryname || 'India',
            whatsAppCountryCode: formData.whatsAppCountryCode || '+91',
            addressState: formData.addressState,
            addressCountry: formData.addressCountry,
            cin: formData.cin,
            tin: formData.tin,
            dateTimeFormat: formData.dateTimeFormat || ''
          },
          uuid ? uuid : ''
        );
        if (response.ok) {
          const data = await response.json();
          ToastNotification({
            message: data.message
          });
          if (!isSettings) {
            businessType === 'Retail'
              ? navigate('/account-setup/faq')
              : navigate('/account-setup/create-menu');
          }
          sessionStorage.setItem('companyName', formData.companyName);
          sessionStorage.setItem('dateTimeFormat', formData.dateTimeFormat);
          setDisable(false);
        } else {
          const errorData = await response.json();
          ToastNotification({
            message: errorData.message,
            type: 'warning'
          });
          setDisable(false);
        }
      } catch (error) {
        setDisable(false);
      }
    }
  };

  const fetchCompanyDetails = async () => {
    try {
      const companyData = await getCompanyDetails(uuid ? uuid : '');
      const companyDetails: any = companyData?.payload?.companyDetail;
      if (companyDetails) {
        setFormData({
          companyName: companyDetails?.companyName || '',
          contactNumber: companyDetails?.phone || '',
          supportEmail: companyDetails?.supportEmail || '',
          address: companyDetails?.address || '',
          whatsAppNumber: companyDetails?.whatsAppNumber || '',
          email: companyDetails?.email || '',
          Countrycode: companyDetails?.code || formData.Countrycode || countrycodes[0].teleCode,
          Countryname: companyDetails?.country || '',
          whatsAppCountryCode: companyDetails?.whatsAppCountryCode || formData.whatsAppCountryCode,
          addressState: companyDetails?.addressState || '',
          addressCountry: companyDetails?.addressCountry || '',
          cin: companyDetails?.companyIdentificationNumber || '',
          tin: companyDetails?.taxIdentificationNumber || '',
          dateTimeFormat: companyDetails?.dateTimeFormat || ''
        });
        if (companyDetails?.dateTimeFormat) {
          setSelectedDateTimeFormat(companyDetails?.dateTimeFormat);
        }
        const selected_Country =
          countrycodes.find((country) => country.teleCode === companyDetails.code) ||
          countrycodes[0];
        if (selected_Country) {
          setSelectedCountry(selected_Country);
        }
        const selectedWhatsAppCountry =
          countrycodes.find((country) => country.teleCode === companyDetails.whatsAppCountryCode) ||
          countrycodes[0];
        if (selectedWhatsAppCountry) {
          setSelectedWhatsAppCountry(selectedWhatsAppCountry);
        }
      }
    } catch (error) {
      console.error('Error fetching company details:', error);
      setErrors((prev) => ({ ...prev, fetch: 'Failed to fetch company details.' }));
    }
  };

  // useEffect(() => {
  //   handlePhoneChange(formData.Countrycode);
  // }, [formData.contactNumber]);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsOpen(false);
        setSearchQuery('');
      }
      if (dropdownRef1.current && !dropdownRef1.current.contains(event.target as Node)) {
        setIsWhatsappOpen(false);
        setSearchQueryWhatsaap('');
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (selectedCountry) {
      setFormData((prevData: any) => ({
        ...prevData,
        Countryname: selectedCountry.name,
        Countrycode: selectedCountry.teleCode
      }));
    }
  }, [selectedCountry]);

  useEffect(() => {
    if (selectedWhatsAppCountry) {
      setFormData({
        ...formData,
        whatsAppCountryCode: selectedWhatsAppCountry.teleCode
      });
    }
  }, [selectedWhatsAppCountry]);

  useEffect(() => {
    fetchCompanyDetails();
  }, []);

  useEffect(() => {
    if (selectedDateTimeFormat) {
      setFormData((prevData: any) => ({
        ...prevData,
        dateTimeFormat: selectedDateTimeFormat
      }));
    }
  }, [selectedDateTimeFormat]);

  return (
    <div className="flex flex-col flex-1 bg-[#1E1E1E] rounded-lg lg:px-8 md:pt-3 lg:pt-6 p-2 overflow-y-auto">
      {!isSettings && (
        <>
          <h2 className="lg:text-base md:text-base  text-[14px] font-normal md:mb-[5px] mb-1  ms-1  ">
            STEP 1
          </h2>
          <h3 className="lg:text-base md:text-base mt-1 md:mt-2 text-[16px] md:mb-[15px] mb-4 font-medium ms-1">
            Create Profile
          </h3>
        </>
      )}

      <form
        className="flex flex-col flex-1 ms-1"
        onSubmit={handleCreateCompanyProfile}
        method="Post"
      >
        <div className={'flex gap-10'}>
          <div className={`${isSettings ? 'w-[85%]' : 'w-[58%]'}`}>
            <div className="grid grid-cols-1 gap-x-[60px]">
              <div>
                <label className="text-[#FFFFFF] block text-[13px]  sm:leading-[26.86px] lg:text-sm md:text-sm md:leading-[28.05px] font-normal  mb-[8px] ">
                  Company Name
                </label>
                <div>
                  <AccountSetupInputBox
                    name="companyName"
                    type="text"
                    value={formData.companyName}
                    placeholder="Company name"
                    handleChange={handleChange}
                    error={errors.companyName}
                  />
                </div>
              </div>

              <div className="grid xl:grid-cols-2 lg:grid-cols-1 md:grid-cols-2 grid-cols-1 md:gap-8 gap-3">
                <div>
                  <label className="text-[#FFFFFF] block text-[13px] sm:leading-[26.86px] lg:text-sm md:text-sm font-normal  mb-[8px]">
                    CIN
                  </label>
                  <div className="mt-1">
                    <AccountSetupInputBox
                      name="cin"
                      type="text"
                      value={formData.cin}
                      placeholder="Company Identification Number"
                      handleChange={handleChange}
                      error={errors.cin}
                    />
                  </div>
                </div>
                <div>
                  <label className="text-[#FFFFFF] block text-[13px] sm:leading-[26.86px] lg:text-sm md:text-sm font-normal  mb-[8px]">
                    TIN
                  </label>
                  <div className="mt-1">
                    <AccountSetupInputBox
                      name="tin"
                      type="text"
                      value={formData.tin}
                      placeholder="Tax Identification Number"
                      handleChange={handleChange}
                      error={errors.tin}
                    />
                  </div>
                </div>
              </div>

              <div className="grid xl:grid-cols-2 lg:grid-cols-1 md:grid-cols-2 grid-cols-1 md:gap-8 gap-3">
                <div>
                  <label className="text-[#FFFFFF] block text-[13px] sm:leading-[26.86px] lg:text-sm md:text-sm  font-normal  mb-[8px]">
                    Contact number
                  </label>
                  <div className="flex gap-2">
                    <CountryCode
                      formData={formData}
                      isOpen={isOpen}
                      searchQuery={searchQuery}
                      selectedCountry={selectedCountry}
                      dropdownRef={dropdownRef}
                      filteredCountries={filteredCountries}
                      toggleDropdown={toggleDropdown}
                      handleSearch={handleSearch}
                      handleSelect={handleSelect}
                      countrycodes={countrycodes}
                    />
                    <div className="w-full">
                      <AccountSetupInputBox
                        name="contactNumber"
                        type="text"
                        value={formData.contactNumber}
                        placeholder="Contact Number"
                        error={errors.contactNumber}
                        handleChange={(e) => {
                          const value = e.target.value;
                          if (phoneNumberRangeRegex.test(value)) {
                            handleChange(e);
                          }
                        }}
                      />
                    </div>
                  </div>
                </div>
                <div>
                  <label className="text-[#FFFFFF] block text-[13px] sm:leading-[26.86px] lg:text-sm md:text-sm  font-normal  mb-[8px]">
                    Email
                  </label>
                  <div>
                    <AccountSetupInputBox
                      name="email"
                      type="email"
                      value={formData.email}
                      placeholder="Email"
                      handleChange={handleChange}
                      error={errors.email}
                      disabled={formData.email}
                    />
                  </div>
                </div>
              </div>

              <label className="text-[#FFFFFF] block text-[13px] sm:leading-[26.86px] lg:text-sm md:text-sm md:leading-[28.05px] font-normal  mb-[8px]">
                Address
              </label>
              <div>
                <AccountSetupInputBox
                  name="address"
                  type="text"
                  value={formData.address}
                  placeholder="Address"
                  handleChange={handleChange}
                  error={errors.address}
                />
              </div>

              <div className="grid xl:grid-cols-2 lg:grid-cols-1 md:grid-cols-2 grid-cols-1 md:gap-8 gap-3">
                <div>
                  <label className="text-[#FFFFFF] block text-[13px] sm:leading-[26.86px] lg:text-sm md:text-sm font-normal  mb-[8px]">
                    State
                  </label>
                  <div className="mt-1">
                    <AccountSetupInputBox
                      name="addressState"
                      type="text"
                      value={formData.addressState}
                      placeholder="State"
                      handleChange={handleChange}
                      error={errors.addressState}
                    />
                  </div>
                </div>
                <div>
                  <label className="text-[#FFFFFF] block text-[13px] sm:leading-[26.86px] lg:text-sm md:text-sm font-normal  mb-[8px]">
                    Country
                  </label>
                  <div className="mt-1">
                    <AccountSetupInputBox
                      name="addressCountry"
                      type="text"
                      value={formData.addressCountry}
                      placeholder="Country"
                      handleChange={handleChange}
                      error={errors.addressCountry}
                    />
                  </div>
                </div>
              </div>
              <div className="mb-2">
                <label className="text-[#FFFFFF] block text-[13px]  sm:leading-[26.86px] lg:text-sm md:text-sm md:leading-[28.05px] font-normal  mb-[8px] ">
                  Date Time Format
                </label>
                <select
                  name="type"
                  className="text-white focus:bg-[#343434] text-xs md:text-sm font-normal w-full
                  px-[5px] md:px-[7px] xl:px-3 py-2 lg:h-[35px] md:h-8 h-9 rounded-lg border-0 shadow-sm bg-[#343434] 
                  placeholder:text-[#F3F3E099] placeholder:font-normal text-[12px] lg:text-sm sm:leading-[28.13px]"
                  value={selectedDateTimeFormat}
                  onChange={(e) => setSelectedDateTimeFormat(e.target.value)}
                >
                  <option value="" disabled>
                    Select option
                  </option>
                  {dateTimeFormatList?.map((data) => (
                    <option key={data.format} value={data.format}>
                      {data.todayDate}
                    </option>
                  ))}
                </select>
                {errors.dateTimeFormat && (
                  <div
                    className={`block h-[16px] ${errors.dateTimeFormat && `mb-3`}  font-normal text-[10px] md:text-sm md:leading-[22.8px]`}
                  >
                    {' '}
                    <p className="error text-[#ff4c4c]">{errors.dateTimeFormat}</p>
                  </div>
                )}
              </div>
            </div>

            <div className="my-4 mt-1">
              <label className="lg:text-sm md:text-sm text-[14px]  font-medium">
                To get connect with customers add your WhatsApp number and Business Email address
              </label>
            </div>
            <div className="grid xl:grid-cols-2 lg:grid-cols-1 md:grid-cols-2 grid-cols-1 md:gap-8 gap-3 md:mt-3 mt-1">
              <div>
                <label className="text-[#FFFFFF] block text-[13px] sm:leading-[26.86px] lg:text-sm md:text-sm font-normal  mb-[8px]">
                  WhatsApp Number
                </label>
                <div className="flex gap-2 mt-1 mb-3">
                  <CountryCode2
                    formData={formData}
                    isOpen={isWhatsappOpen}
                    searchQuery={searchQuerywhatsaap}
                    selectedCountry={selectedWhatsAppCountry}
                    dropdownRef={dropdownRef1}
                    filteredCountries={filteredCountrieswhatsaap}
                    toggleDropdown={toggleWhatsappDropdown}
                    handleSearch={handelSearchWhatsaap}
                    handleSelect={handleWhatsAppSelect}
                    countrycodes={countrycodes}
                  />
                  <div className="w-full">
                    <AccountSetupInputBox
                      name="whatsAppNumber"
                      type="text"
                      value={formData.whatsAppNumber}
                      placeholder="WhatsApp Number"
                      error={errors.whatsAppNumber}
                      handleChange={(e) => {
                        const value = e.target.value;
                        if (phoneNumberRangeRegex.test(value)) {
                          handleChange(e);
                        }
                      }}
                    />
                  </div>
                </div>
              </div>

              <div>
                <label className="text-[#FFFFFF] block text-[13px] sm:leading-[26.86px] lg:text-sm md:text-sm font-normal  mb-[8px]">
                  Business Email Address
                </label>
                <div className="mt-1">
                  <AccountSetupInputBox
                    name="supportEmail"
                    type="email"
                    value={formData.supportEmail}
                    placeholder="Email"
                    handleChange={handleChange}
                    error={errors.supportEmail}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="flex justify-end -mt-5">
          <AccountSetupButton
            isFormValid={true}
            disable={disable}
            btnText={!isSettings ? 'Next' : 'Update'}
            textColor="#FFFFFF"
            backGroundColor="#006BEA"
          />
        </div>
      </form>

      {disable && (
        <>
          <div className="fixed inset-0 bg-black bg-opacity-50 z-40"></div>

          <div className="fixed inset-0 flex items-center justify-center z-50">
            <div className="loader border-t-4 border-[#006BEA] rounded-full w-12 h-12 animate-spin"></div>
          </div>
        </>
      )}
    </div>
  );
};

export default CreateCompanyProfile;
